export {};

window.addEventListener('started-user', () => {
    const qs = document.location.search ? document.location.search : '?tvcode=';
    document.location.href = config.routes.settings_devices_smarttv + qs;
});

window.addEventListener('started-guest', () => {
    const qs = document.location.search ? document.location.search : '?tvcode=';
    document.location.href = config.routes.login + qs;
});
